var _style, _circle, _path, _path2, _path3, _path4, _path5, _feBlend, _feBlend2, _feBlend3, _feBlend4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 838 154",
    style: {
      enableBackground: "new 0 0 838 154"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:#FFFFFF;}\n\t.st1{fill:#50AED4;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{opacity:0.1;fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_00000067220907476218688730000003564217046102426016_);}\n\t.st5{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st6{filter:url(#Adobe_OpacityMaskFilter_00000127015007768751032690000006023992616717164987_);}\n\t\n\t\t.st7{mask:url(#SVGID_00000026146576335404841710000007077096723664446399_);fill:url(#SVGID_00000165222215354918687670000014085139903855369134_);}\n\t.st8{fill:url(#SVGID_00000083809903068487969150000002657199712310613915_);}\n\t.st9{filter:url(#Adobe_OpacityMaskFilter_00000097491497331433497360000005600452867627318676_);}\n\t.st10{filter:url(#Adobe_OpacityMaskFilter_00000018948404009965500390000016548249715508385435_);}\n\t\n\t\t.st11{mask:url(#SVGID_00000119805614826691331530000015846171920310039458_);fill:url(#SVGID_00000085230149062692745110000011952197111325409672_);}\n\t.st12{fill:url(#SVGID_00000143581862427643994600000010428464528484114098_);}\n")), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 784.8,
    cy: 20.6,
    r: 4.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M799.1,24.7c0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9c0-1.6,1.3-2.9,2.9-2.9S799.1,23.1,799.1,24.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M765.2,151.4h-698C31.3,149.8,0,118.5,0,79.8v0c0-38.7,31.3-70,70-70h698c38.7,0,70,31.3,70,70v0 C838,118.5,806.7,149.8,765.2,151.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 419,
    y1: 142.6602,
    x2: 419,
    y2: 2.6558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50AED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    style: {
      stopColor: "#62BDD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2FFEE"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M768,142.7H70c-38.7,0-70-31.3-70-70v0c0-38.7,31.3-70,70-70h698c38.7,0,70,31.3,70,70v0 C838,111.3,806.7,142.7,768,142.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M768,2.7H70C31.3,2.7,0,34,0,72.7v0c0,8.8,1.6,17.2,4.6,25C14.6,71.3,40.1,52.6,70,52.6h698 c29.9,0,55.4,18.7,65.4,45.1c3-7.8,4.6-16.2,4.6-25v0C838,34,806.7,2.7,768,2.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70,52.6h698c26.7,0,49.9,15,61.7,37c-11.8-25-35-42.1-61.7-42.1H70c-26.7,0-49.9,17-61.7,42.1 C20.1,67.5,43.3,52.6,70,52.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000071522595512955956310000005715726835319828621_",
    gradientUnits: "userSpaceOnUse",
    x1: 419,
    y1: 142.6601,
    x2: 419,
    y2: 2.6558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#50AED4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03161561,
    style: {
      stopColor: "#53B0D5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3DDFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000071522595512955956310000005715726835319828621_)"
    },
    d: "M768,9.8c34.7,0,62.8,28.2,62.8,62.8 c0,34.7-28.2,62.8-62.8,62.8H70c-34.7,0-62.8-28.2-62.8-62.8C7.2,38,35.4,9.8,70,9.8H768 M768,2.7H70C31.3,2.7,0,34,0,72.7v0 c0,38.7,31.3,70,70,70h698c38.7,0,70-31.3,70-70v0C838,34,806.7,2.7,768,2.7L768,2.7z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 233,
    y: 2.6,
    width: 369.4,
    height: 7.2
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 2.6,
    width: 369.4,
    height: 7.2,
    id: "SVGID_00000007414601841417057790000001215429009793419403_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000107582202272479337610000013043887069053391253_",
    filterUnits: "userSpaceOnUse",
    x: 233,
    y: 2.6,
    width: 369.4,
    height: 7.2
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 233,
    y: 2.6,
    width: 369.4,
    height: 7.2,
    id: "SVGID_00000007414601841417057790000001215429009793419403_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000107582202272479337610000013043887069053391253_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094594233276707036420000002334998598345521845_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.9503,
    y1: 6.2004,
    x2: 602.3862,
    y2: 6.2004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8338,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 2.6,
    style: {
      mask: "url(#SVGID_00000007414601841417057790000001215429009793419403_)",
      fill: "url(#SVGID_00000094594233276707036420000002334998598345521845_)"
    },
    width: 369.4,
    height: 7.2
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038390875158274795820000015892017495587660696_",
    gradientUnits: "userSpaceOnUse",
    x1: 232.9503,
    y1: 6.2004,
    x2: 602.3862,
    y2: 6.2004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBFFEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#BBFFEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBFFEA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 2.6,
    style: {
      fill: "url(#SVGID_00000038390875158274795820000015892017495587660696_)"
    },
    width: 369.4,
    height: 7.2
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000102544485288213084800000008691336135320457909_",
    filterUnits: "userSpaceOnUse",
    x: 150.3,
    y: 142.7,
    width: 504.9,
    height: 7.2
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 150.3,
    y: 142.7,
    width: 504.9,
    height: 7.2,
    id: "SVGID_00000130640932955445678480000012539660311836398763_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000102544485288213084800000008691336135320457909_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000024689583911890290020000014487819600877060239_",
    filterUnits: "userSpaceOnUse",
    x: 150.3,
    y: 142.7,
    width: 504.9,
    height: 7.2
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 150.3,
    y: 142.7,
    width: 504.9,
    height: 7.2,
    id: "SVGID_00000130640932955445678480000012539660311836398763_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000024689583911890290020000014487819600877060239_)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143593988204942305080000003607459113187394486_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.3474,
    y1: 146.2411,
    x2: 655.2747,
    y2: 146.2411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8338,
    style: {
      stopColor: "#515151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 142.7,
    style: {
      mask: "url(#SVGID_00000130640932955445678480000012539660311836398763_)",
      fill: "url(#SVGID_00000143593988204942305080000003607459113187394486_)"
    },
    width: 504.9,
    height: 7.2
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142883632308293938430000010701343295298811797_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.3474,
    y1: 146.2411,
    x2: 655.2747,
    y2: 146.2411
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBFFEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4978,
    style: {
      stopColor: "#BBFFEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BBFFEA"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 150.3,
    y: 142.7,
    style: {
      fill: "url(#SVGID_00000142883632308293938430000010701343295298811797_)"
    },
    width: 504.9,
    height: 7.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBlue);
export default __webpack_public_path__ + "static/media/button-blue.39a9a6fe73bdfb447a244600e699a289.svg";
export { ForwardRef as ReactComponent };